module.exports = __webpack_public_path__ + "static/media/fresh-grezel.601314a1.png";